<template>
  <div class="canvas-container" ref="canvasContainer">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import MultiVariableLineChart from "@/components/utils/MultiVariableLineChart.vue";

export default {
  name: "KoioteValueLabel",

  components: { MultiVariableLineChart },

  props: {
    input: Object,
  },

  data() {
    return {
      mounted:false,
      showHistoryDialog: false,
      value: "?",
      resizeTimeout: null, // Para debounce
      prevWidth: 0,
      prevHeight: 0,
    };
  },

  computed: {
    ...mapGetters(["actualPage"]),
    ...mapState("nodered", ["client"]),
    valueLabelStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "100%",
        height: "100%",
        position: "absolute",
        alignContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
      };
    },

    label() {
      return this.input.customized?.label?.length > 0 ? `${this.value}: ` : "";
    },
  },

  methods: {
    ...mapActions("nodered", ["setShowingHistoryAddress", "doSubscribe"]),
    atenderMensajeMqtt() {
      // Si atiende a broker MQTT
      if (this.input.customized.tipo_lectura == 2) {
        if (this.input.customized.textoValor == 1) {
          this.doSubscribe(this.input.customized.topic_lectura);
          this.client.on("message", (topic, message) => {
            if (topic == this.input.customized.topic_lectura) {
              const res = JSON.parse(message.toString());
              const miVariable = res.find((v)=> v.name==this.input.customized.memoria);
              if(miVariable){
                this.value = miVariable.value;
                // console.log(miVariable, res)
              }

              
            }
          });
        }
      }
    },

    setupResizeObserver() {
      // Crear una instancia de ResizeObserver
      this.resizeObserver = new ResizeObserver(() => {
        this.dibujarTexto(); // Redibujar el canvas cuando el tamaño cambia
      });

      // Observar el contenedor del canvas para detectar cambios de tamaño
      this.resizeObserver.observe(this.$refs.canvasContainer);
    },
    dibujarTexto() {
  const canvas = this.$refs.canvas;

  // Verificar si el canvas está disponible
  if (!canvas) {
    console.error("Canvas no está disponible");
    return;
  }

  const ctx = canvas.getContext("2d");
  const container = this.$refs.canvasContainer;

  // Establecer el tamaño del canvas igual al del contenedor
  canvas.width = container.offsetWidth;
  canvas.height = container.offsetHeight;

  // Limpiar el canvas antes de dibujar (borrar contenido previo)
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Establecer el color de fondo
  ctx.fillStyle = this.input.customized.background_color;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Establecer el color del texto
  ctx.fillStyle = this.input.customized.foreground_color;

  // Ajuste dinámico del tamaño de la fuente
  let fontSize = Math.floor(canvas.height / 1); // El tamaño de la fuente es el 100% de la altura del canvas

  // Asegurarse de que la fuente no sea demasiado grande
  if (fontSize > canvas.width / 2) {
    fontSize = Math.floor(canvas.width / 2); // Limitar el tamaño máximo para que el texto no se desborde
  }

  // Establecer la fuente
  ctx.font = `${fontSize}px Arial`;

  // Ajustar el tamaño de la fuente para que el texto se ajuste dentro del canvas
  while (ctx.measureText(this.value).width > canvas.width - 20 && fontSize > 10) {
    fontSize -= 1;
    ctx.font = `${fontSize}px Arial`;
  }

  // Calcular la posición para centrar el texto
  const x = (canvas.width - ctx.measureText(this.value).width) / 2;
  const y = canvas.height / 2 + fontSize / 4;

  // Dibujar el texto en el canvas
  ctx.fillText(this.value, x, y);
}

  },

  watch: {
    showHistoryDialog(value) {
      this.setShowingHistoryAddress(value ? this.input.customized.address : "");
    },
    value(newVal, oldVal) {
      if(!this.mounted)return;
      // Solo redibujar si el valor ha cambiado
      if (newVal !== oldVal) {
        console.log("Pintamos por cambio de valor")
        this.dibujarTexto();
      }
    },
  },

  mounted() {
    this.atenderMensajeMqtt();
    this.$nextTick(() => {
      console.log("Vamos a dibujar en el mounted")
      this.dibujarTexto(); // Llamada a dibujarTexto una vez el DOM esté listo
    });
    this.setupResizeObserver(); // Configurar el observer
    this.mounted = true;
  },
};
</script>

<style scoped>
.canvas-container {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
}
canvas {
  display: block;
}

.KoioteValueLabel {
  font-size: 1vw;
}

@media (orientation: portrait) {
  .KoioteValueLabel {
    font-size: 1.3vw;
  }
}

@media (orientation: landscape) and (max-width: 600px) {
  .KoioteValueLabel {
    font-size: 0.85vw;
  }
}

@media (orientation: portrait) and (max-width: 500px) {
  .KoioteValueLabel {
    font-size: 1.55vw;
  }
}
</style>
